import React from 'react'
import { useNavigate } from 'react-router-dom'
import { clearAuthData, getUserInfoSync } from '../../config/api'
import logo from '../../assets/logo.jpeg'

const TopBar = ({ onToggleSidebar, setActiveScreen }) => {
  const navigate = useNavigate()
  const userInfo = getUserInfoSync()

  // Get user display name
  const getUserDisplayName = () => {
    if (userInfo?.employee_name) return userInfo.employee_name
    if (userInfo?.full_name) return userInfo.full_name
    if (userInfo?.first_name && userInfo?.last_name) return `${userInfo.first_name} ${userInfo.last_name}`
    if (userInfo?.username) return userInfo.username
    if (userInfo?.email) return userInfo.email.split('@')[0]
    return 'User'
  }

  const handleProfileClick = (e) => {
    e.preventDefault()
    if (setActiveScreen) {
      setActiveScreen('profile')
    }
  }

  const handleToggleClick = (e) => {
    e.preventDefault()
    if (onToggleSidebar) {
      onToggleSidebar()
    }
  }

  const handleLogout = (e) => {
    e.preventDefault()
    clearAuthData()
    navigate('/login')
  }

  return (
<header id="header" className="header fixed-top d-flex align-items-center">
  <div className="d-flex align-items-center justify-content-between">
    <a href="/" className="logo d-flex align-items-center">
      <img src={logo} alt="Logo" />
      <span className="d-none d-lg-block">Sell Smart</span>
    </a>
    <i className="bi bi-list toggle-sidebar-btn" onClick={handleToggleClick} style={{ cursor: 'pointer' }} />
  </div>{/* End Logo */}

  <nav className="header-nav ms-auto">
    <ul className="d-flex align-items-center">
      <li className="nav-item d-block d-lg-none">
        <button className="nav-link nav-icon search-bar-toggle btn btn-link p-0 border-0" type="button">
          <i className="bi bi-search" />
        </button>
      </li>{/* End Search Icon*/}
      
     
      <li className="nav-item dropdown pe-3">
        <button className="nav-link nav-profile d-flex align-items-center pe-0 btn btn-link border-0" type="button" data-bs-toggle="dropdown">
          <img src="assets/img/profile-img.jpg" alt="Profile" className="rounded-circle" />
          <span className="d-none d-md-block dropdown-toggle ps-2">{getUserDisplayName()}</span>
        </button>{/* End Profile Iamge Icon */}
        <ul className="dropdown-menu dropdown-menu-end dropdown-menu-arrow profile">
          <li className="dropdown-header">
            <h6>{getUserDisplayName()}</h6>
            <span>{userInfo?.role_display || 'User'}</span>
          </li>
          <li>
            <hr className="dropdown-divider" />
          </li>
          <li>
            <button className="dropdown-item d-flex align-items-center" type="button" onClick={handleProfileClick} style={{ cursor: 'pointer' }}>
              <i className="bi bi-person" />
              <span>My Profile</span>
            </button>
          </li>
          <li>
            <hr className="dropdown-divider" />
          </li>
          <li>
            <button className="dropdown-item d-flex align-items-center" type="button" onClick={handleLogout} style={{ cursor: 'pointer' }}>
              <i className="bi bi-box-arrow-right" />
              <span>Sign Out</span>
            </button>
          </li>
        </ul>{/* End Profile Dropdown Items */}
      </li>{/* End Profile Nav */}
    </ul>
  </nav>{/* End Icons Navigation */}
</header>

  )
}

export default TopBar